import { useState } from 'react';
import { uploadImage, deleteImage } from '../utils/cloudFlareImages';

const useCloudFlareImages = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleUpload = async (imageFiles) => {
    try {
      setUploading(true);
      const imageUrls = await Promise.all(imageFiles.map(file => uploadImage(file)));
      return imageUrls;
    } catch (error) {
      setError(error);
      throw error;
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (imageName) => {
    try {
      await deleteImage(imageName);
    } catch (error) {
      setError(error);
      throw error;
    }
  };

  return { handleUpload, handleDelete, uploading, error };
};

export default useCloudFlareImages;